import { useQuery } from '@tanstack/react-query';
import { apiClient } from '@/api/client';
import { API_SAME_LEVEL_CLASSES } from '@/api/endpoints';
import { SAME_LEVEL_CLASSES_QUERY_KEY } from '@/api/queryKeys';
import type { SameLevelClass } from '@/types/ratings';
import { unwrapAxiosResponse } from '@/utils/axios';

export const useSameLevelClasses = ({ enabled }: { enabled: boolean }) =>
  useQuery<SameLevelClass[]>({
    queryKey: SAME_LEVEL_CLASSES_QUERY_KEY,
    enabled,
    staleTime: Infinity,
    queryFn: () =>
      apiClient
        .get<SameLevelClass[]>(API_SAME_LEVEL_CLASSES)
        .then(unwrapAxiosResponse),
  });
